var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-fakture"},[_c('img',{staticClass:"path-4",attrs:{"src":"/otplanding/path-6@2x.png","alt":"Path"}}),_c('div',{staticClass:"anastasia-dan-ux-b-6 inter-medium-link-water-16px"},[_vm._v("izlaznim i ulaznim e-fakturama")])])
}]

export { render, staticRenderFns }